import { Component, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'app-scroll-to-top',
  templateUrl: './scroll-to-top.component.html',
  styleUrls: ['./scroll-to-top.component.scss'],
})
export class ScrollToTopComponent implements OnInit {
  showScroll: boolean;
  showScrollHeight = 300;
  hideScrollHeight = 10;

  constructor() {}

  ngOnInit() {}

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.showScroll =
      (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) > this.showScrollHeight;
  }

  scrollToTop() {
    const body = document.querySelector('body');
    body.scrollIntoView({ behavior: 'smooth' });
  }
}
